import Image from 'next/image';
import Link from 'next/link';
import ReactPlayer from 'react-player';

import { SeoHead } from '@components/SeoHead';
import { AboutItem } from '@components/about/AboutItem';
import aboutItems, { mainText } from '@components/about/aboutConfig';

import useTranslation from '@hooks/useTranslation';
import { PageLayout } from '@layout';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';

const AboutPage = () => {
    const theme = useTheme();
    const { t } = useTranslation('library');
    const { t: tLayout } = useTranslation('layout');
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const introText = (
        <Typography
            sx={{
                color: '#121212',
                lineHeight: '36px',
                textAlign: 'justify',
            }}
        >
            {mainText}
        </Typography>
    );

    const aboutTamayyuz = isMobile ? (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column-reverse',
            }}
        >
            <Box
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    fontSize: { xs: '11px', sm: '12px', md: '16px' },
                    pb: { xs: '15px', sm: 0 },
                }}
            >
                {tLayout('copyright')} {new Date().getFullYear()}
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Link
                    href="https://www.facebook.com/profile.php?id=61563783331635"
                    target="_blank"
                >
                    <FacebookIcon color="primary" />
                </Link>
                <Link href="https://x.com/alminasaai" target="_blank">
                    <XIcon color="primary" />
                </Link>
                <Link href="https://t.me/alminasaai" target="_blank">
                    <TelegramIcon color="primary" />
                </Link>
                <Link
                    href="https://www.youtube.com/channel/UCp1yewzLiNK2W_xM_lFK_DA"
                    target="_blank"
                >
                    <YouTubeIcon color="primary" />
                </Link>
                <Link
                    href="https://www.instagram.com/alminasaai/"
                    target="_blank"
                >
                    <InstagramIcon color="primary" />
                </Link>
            </Box>

            <Box>
                <Link href="https://tamayyuzcenter.com/" target="_blank">
                    <Image
                        alt="logo"
                        src="/images/tamayuz1.svg"
                        width={50}
                        height={50}
                    />
                </Link>
            </Box>
        </Box>
    ) : null;

    return (
        <>
            <SeoHead />
            <PageLayout>
                <Paper
                    variant={isMobile ? 'elevation' : 'outlined'}
                    elevation={0}
                    sx={{
                        padding: '30px 40px 40px 40px',
                        mt: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2,
                    }}
                >
                    <Typography
                        color={'primary'}
                        sx={{
                            width: '100%',
                            textAlign: 'center',
                            fontWeight: 900,
                        }}
                    >
                        من نحن وماذا نقدم لك؟
                    </Typography>
                    {introText}

                    <Box>
                        <Typography
                            color={'primary'}
                            sx={{
                                width: '100%',
                                textAlign: 'center',
                                fontWeight: 900,
                            }}
                        >
                            {t('intro_video_title')}
                        </Typography>
                    </Box>
                    <ReactPlayer
                        url={'https://youtu.be/14dEWS26eRc?si=GjbvsL2Kb10bybm2'}
                        width={isMobile ? '95vw' : undefined}
                        playing={false}
                        controls={true}
                        config={{
                            file: {
                                attributes: {
                                    controlsList: 'nodownload',
                                },
                            },
                        }}
                    />

                    <Box>
                        <Typography
                            color={'primary'}
                            sx={{
                                width: '100%',
                                textAlign: 'center',
                                fontWeight: 900,
                            }}
                        >
                            {t('features')}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 2,
                            flexWrap: 'wrap',
                        }}
                    >
                        {aboutItems.map((aboutItem, index) => {
                            return (
                                <Box key={aboutItem.srcImage}>
                                    <Box
                                        // onClick={() => handleItemOnclick(index)}
                                        sx={{
                                            height: '160px',
                                            width: '195px',
                                        }}
                                    >
                                        <AboutItem
                                            srcImg={aboutItem.srcImage}
                                            title={aboutItem.title}
                                            body={aboutItem.body}
                                        />
                                    </Box>
                                </Box>
                            );
                        })}
                    </Box>
                    {aboutTamayyuz}
                </Paper>
            </PageLayout>
        </>
    );
};

export default AboutPage;
